<template>
    <div class="col-span-12 lg:col-span-10">
        <page-header class="mb-2 md:mb-2">
            <slot name="page-header">Users</slot>
        </page-header>

        <vx-tabs v-if="showTabs" v-model="currentTab" size="lg" class="mb-8">
            <vx-tab value="active">Active</vx-tab>
            <vx-tab value="pending">
                <span class="relative">
                    Pending
                    <span
                        class="absolute -inset-e-1.5 inset-bs-0 bg-sky-500 w-1.5 h-1.5 rounded-full"
                    ></span>
                </span>
            </vx-tab>
        </vx-tabs>

        <group-active-users
            v-show="currentTab === 'active'"
            ref="activeUsersRef"
            :groupId="props.groupId"
            :groupName="props.groupName"
            :teamId="props.teamId"
            :canManageUsers="props.canManageUsers"
            @added="onAdded"
            @updated="onUpdated"
            @invited="onInvited"
        ></group-active-users>
        <group-pending-users
            v-show="currentTab === 'pending'"
            ref="pendingUsersRef"
            :groupId="props.groupId"
            :groupName="props.groupName"
            :teamId="props.teamId"
            :canManageUsers="props.canManageUsers"
            :totalCount="invitesCount"
            @added="onAdded"
            @updated="onUpdated"
            @invited="onInvited"
            @deleted="onInviteDeleted"
        ></group-pending-users>
    </div>
</template>
<script setup>
import {
    VxTabs,
    VxTab,
} from '@voxie/frontend-components';
import PageHeader from '~/components/general/PageHeader.vue';
import { groupInvitationsClient } from '~/services';
import { useToasted } from '~/composables/useToasted';
import GroupActiveUsers from './GroupActiveUsers.vue';
import GroupPendingUsers from './GroupPendingUsers.vue';
import { ref } from 'vue';

const toasted = useToasted();

const props = defineProps({
    teamId: {
        type: Number,
        required: true,
    },
    groupId: {
        type: String,
        required: true,
    },
    groupName: {
        type: String,
        default: '',
    },
    canManageUsers: {
        type: Boolean,
        default: false,
    },
});

const showTabs = ref(false);
const currentTab = ref('active');

const activeUsersRef = ref(null);
const pendingUsersRef = ref(null);
const invitesCount = ref(0);

groupInvitationsClient
    .invitationsCount(props.teamId, props.groupId)
    .then(({ data }) => {
        invitesCount.value = data.count || 0;
        showTabs.value = invitesCount.value > 0;
    })
    .catch((e) => {
        console.error(e);
        toasted.global.platform_error();
    });

const onAdded = () => {
    if (currentTab.value === 'pending') {
        activeUsersRef?.value?.loadData();
    }
}

const onUpdated = () => {
    if (currentTab.value === 'pending') {
        activeUsersRef?.value?.loadData();
    }
}

const onInvited = () => {
    pendingUsersRef?.value?.loadData();
    invitesCount.value++;
    showTabs.value = true;
}

const onInviteDeleted = () => {
    invitesCount.value--;
    showTabs.value = invitesCount.value > 0;

    currentTab.value = showTabs.value ? 'pending' : 'active';
}
</script>
